module.exports = "../fonts/HelveticaNeueLTW01-56Italic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-56Italic.svg
// module id = Q5iq
// module chunks = 1